import { styled } from "@mui/material";

export const StepsList = styled('ul')(() => ({
  listStyle: 'none',
  margin: 0,
  marginTop: '36px',
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '48px',
}))

export const StepItem = styled('li', {
  shouldForwardProp: (prop) => prop !== 'isOdd',
})<{ isOdd: boolean }>(({ theme, isOdd }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  boxSizing: 'border-box',
  backgroundColor: isOdd ? '#f8f6f4' : '#fff',
  borderRadius: theme.spacing(3),
  padding: '20px',
  boxShadow: '0px 18px 45px rgba(23, 34, 49, 0.08)',
  border: `1px solid rgba(23, 34, 49, 0.05)`,

  // [theme.breakpoints.down('sm')]: {
  //   borderRadius: '0px',
  // },
}))

export const StepMedia = styled('div')(({ theme }) => ({
  width: '100%',
  borderRadius: theme.shape.borderRadius * 2,
  overflow: 'hidden',
  backgroundColor: theme.palette.grey[100],
}))

export const LocationsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}))
